module Meevo.Plugins.Drawer {
	"use strict";

	/**
	* Main Section of drawer 
	*/
	export class TippySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.TippyKiosk> {
		deviceIdPattern: RegExp = /^[a-zA-Z0-9]*$/


		public sectionModelRetrieved(): void {
			super.sectionModelRetrieved();

			this.model.originalDeviceId = this.model.deviceId;
		}
	}
}